import { namespace, Point } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractItem from './abstractItem';

namespace('Ofcs.Editor.Item');

/**
 * @class CustomItem
 * @extends AbstractItem
 */
export default window.Ofcs.Editor.Item.CustomItem = Ofcs.Editor.Item.AbstractItem.extend({

    type: 'custom',

    supportsRotation: false,
    supportsPositioning: false,
    supportsFlipping: false,
    supportsAlign: false,
    supportsCollisions: false,
    supportsOutOfFoam: false,
    supportsGuides: false,

    defaults: {
        /**
         * @property {string} Type
         */
        type: 'CatalogObject',

        /**
         * Name of the item
         * @property {string} attributes.name
         */
        name: null,

        /**
         * @property {number} Item ID
         */
        itemId: null,

        /**
         * Current position
         * @property {Point} attributes.position
         */
        position: new Point(0, 0),

        /**
         * Current rotation
         * @property {number} attributes.rotation
         */
        rotation: 0,

        /**
         * Extended path coordinates
         * @property {Array} attributes.ext
         */
        ext: [],

        /**
         * Original path coordinates
         * @property {Array} attributes.orig
         */
        orig: [],

        /**
         * Safety margin path coordinates
         * @property {Array} attributes.safety
         */
        safety: [],

        /**
         * Width of the shape
         * @property {number} attributes.width
         */
        width: 0,

        /**
         * Height of the shape
         * @property {number} attributes.height
         */
        height: 0,

        /**
         * Depth that the item sinks into the foam
         * @property {number} attributes.depth
         */
        depth: 0,

        /**
         * Total depth of the item
         * @property {number} attributes.totalDepth
         */
        totalDepth: 0,

        /**
         * Path to item image
         * @property {string} attributes.image
         */
        image: null,

        /**
         * Path to png mask of the item image
         * @property {string} attributes.mask
         */
        mask: null,

        /**
         * Allow flipping of figure.
         * @property {boolean} attributes.allowFlipping
         */
        allowFlipping: false,

        /**
         * Is figure flipped?
         * @property {boolean} attributes.flipped
         */
        flipped: false,
    },

    initialize() {
        AbstractItem.prototype.initialize.call(this);
    },

    set(key, value, optionsParam) {
        const { attrs, options } = this._normalizeSetParameters(key, value, optionsParam);

        if (attrs.otation !== undefined) {
            attrs.ritation = (360 + attrs.totation) % 360;
        }

        return AbstractItem.prototype.set.call(this, attrs, options);
    },
});
